(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vep-about]');
    if (!sections.length) return;

    const reveal = (items) => {
      items.forEach((item) => item.classList.add('is-visible'));
    };

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => reveal(section.querySelectorAll('[data-vep-reveal]')));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18 });

    sections.forEach((section) => {
      section.querySelectorAll('[data-vep-reveal]').forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["author-directory-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vep-author-directory]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => {
        section.querySelectorAll('[data-vep-directory-reveal]').forEach((item) => item.classList.add('is-visible'));
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    sections.forEach((section) => {
      section.querySelectorAll('[data-vep-directory-reveal]').forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["author-profile-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vep-author-profile]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => {
        section.querySelectorAll('[data-vep-author-reveal]').forEach((item) => item.classList.add('is-visible'));
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    sections.forEach((section) => {
      section.querySelectorAll('[data-vep-author-reveal]').forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vep-contact]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => {
        section.querySelectorAll('[data-vep-contact-reveal]').forEach((item) => item.classList.add('is-visible'));
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    sections.forEach((section) => {
      section.querySelectorAll('[data-vep-contact-reveal]').forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.onHeaderMediaChange = this.setHeaderHeight.bind(this);
      this.headerMediaQuery.addEventListener('change', this.onHeaderMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerMediaQuery?.removeEventListener('change', this.onHeaderMediaChange);
      this.headerMediaQuery = null;
      this.onHeaderMediaChange = null;
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (
        (this.predictiveSearch && this.predictiveSearch.isOpen) ||
        this.querySelector('details-modal details[open]')
      ) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.onHeaderMediaChange = this.setHeaderHeight.bind(this);
      this.headerMediaQuery.addEventListener('change', this.onHeaderMediaChange);
    }

    disconnectedCallback() {
      this.headerMediaQuery?.removeEventListener('change', this.onHeaderMediaChange);
      this.headerMediaQuery = null;
      this.onHeaderMediaChange = null;
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  function initDesktopHoverMenus(scope = document) {
    const header = scope.querySelector('.header[data-desktop-menu-trigger]');
    if (!header || header.dataset.desktopHoverReady === 'true') return;

    const supportsDesktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const detailsMenus = header.querySelectorAll(
      '.header__inline-menu header-menu > details, .header__compact-menu header-menu > details'
    );

    function hoverEnabled() {
      return header.dataset.desktopMenuTrigger === 'hover' && supportsDesktopHover.matches;
    }

    function setExpanded(details, expanded) {
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function closeOtherMenus(currentDetails) {
      detailsMenus.forEach((details) => {
        if (details !== currentDetails) {
          details.removeAttribute('open');
          setExpanded(details, false);
        }
      });
    }

    detailsMenus.forEach((details) => {
      let closeTimer;
      const summary = details.querySelector('summary');
      setExpanded(details, details.open);
      details.addEventListener('toggle', () => setExpanded(details, details.open));

      if (summary) {
        summary.addEventListener('click', (event) => {
          if (hoverEnabled() && details.open) {
            event.preventDefault();
            setExpanded(details, true);
          }
        });
      }

      details.addEventListener('mouseenter', () => {
        if (!hoverEnabled()) return;
        window.clearTimeout(closeTimer);
        closeOtherMenus(details);
        details.setAttribute('open', '');
        setExpanded(details, true);
      });

      details.addEventListener('mouseleave', () => {
        if (!hoverEnabled()) return;
        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            details.removeAttribute('open');
            setExpanded(details, false);
          }
        }, 180);
      });

      details.addEventListener('focusin', () => {
        if (!hoverEnabled()) return;
        closeOtherMenus(details);
        details.setAttribute('open', '');
        setExpanded(details, true);
      });
    });

    header.dataset.desktopHoverReady = 'true';
  }

  function setLocalizationExpanded(details, expanded) {
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeLocalizationDisclosure(details) {
    details.removeAttribute('open');
    setLocalizationExpanded(details, false);
  }

  function closeOtherLocalizationDisclosures(currentDetails) {
    document.querySelectorAll('.header-localization details[open]').forEach((details) => {
      if (details !== currentDetails) closeLocalizationDisclosure(details);
    });
  }

  function setHeaderDrawerExpanded(details, expanded) {
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function initHeaderDrawerAccessibility(scope = document) {
    scope.querySelectorAll('header-drawer').forEach((drawer) => {
      if (drawer.dataset.headerDrawerAccessibilityReady === 'true') return;

      const details = drawer.querySelector('details');
      if (!details) return;

      const syncExpandedState = () => setHeaderDrawerExpanded(details, details.open);
      syncExpandedState();
      details.addEventListener('toggle', syncExpandedState);
      drawer.dataset.headerDrawerAccessibilityReady = 'true';
    });
  }

  function initHeaderLocalizationDisclosures(scope = document) {
    const disclosures = scope.querySelectorAll('.header-localization__country, .header-localization__language');
    const supportsPointerLeave = window.matchMedia('(hover: hover) and (pointer: fine)');

    disclosures.forEach((details) => {
      if (details.dataset.localizationDisclosureReady === 'true') return;

      let closeTimer;
      setLocalizationExpanded(details, details.open);

      details.addEventListener('toggle', () => {
        if (details.open) closeOtherLocalizationDisclosures(details);
        setLocalizationExpanded(details, details.open);
      });

      details.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));

      details.addEventListener('mouseleave', () => {
        if (!supportsPointerLeave.matches || !details.open) return;

        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            closeLocalizationDisclosure(details);
          }
        }, 180);
      });

      details.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (details.open && !details.contains(document.activeElement) && !details.matches(':hover')) {
            closeLocalizationDisclosure(details);
          }
        });
      });

      details.dataset.localizationDisclosureReady = 'true';
    });

    if (document.documentElement.dataset.headerLocalizationListenersReady === 'true') return;

    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('.header-localization details[open]').forEach((details) => {
        if (!details.contains(event.target)) closeLocalizationDisclosure(details);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.header-localization details[open]').forEach((details) => closeLocalizationDisclosure(details));
    });

    document.documentElement.dataset.headerLocalizationListenersReady = 'true';
  }

  initDesktopHoverMenus();
  initHeaderDrawerAccessibility();
  initHeaderLocalizationDisclosures();
  document.addEventListener('shopify:section:load', (event) => {
    initDesktopHoverMenus(event.target);
    initHeaderDrawerAccessibility(event.target);
    initHeaderLocalizationDisclosures(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-story-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-home-story-video]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const video = section.querySelector('video');
      const toggle = section.querySelector('[data-home-story-toggle]');
      const toggleText = toggle?.querySelector('[data-home-story-toggle-text]');
      const playLabel = toggle?.dataset.playLabel || 'Play video';
      const pauseLabel = toggle?.dataset.pauseLabel || 'Pause video';
      const shouldAutoplay = section.dataset.autoplay === 'true';
      const deferAutoplay = section.dataset.deferAutoplay === 'true';
      if (!video) return;

      let autoplayIsVisible = !deferAutoplay;
      let autoplayRequested = false;
      let hasStarted = false;
      let autoplayObserver;

      const hasPlayableSource = () => Boolean(video.currentSrc || video.querySelector('source[src]'));

      const requestAutoplay = () => {
        if (!shouldAutoplay || !autoplayIsVisible || !hasPlayableSource() || autoplayRequested) return;
        autoplayRequested = true;
        if (!video.currentSrc) video.load();
        video.play().catch(() => {
          autoplayRequested = false;
        });
      };

      const updateAutoplayVisibility = (isVisible) => {
        autoplayIsVisible = isVisible;
        if (isVisible) requestAutoplay();
      };

      const observeAutoplay = () => {
        if (!shouldAutoplay || !deferAutoplay) return;

        if (!('IntersectionObserver' in window)) {
          const bounds = video.getBoundingClientRect();
          updateAutoplayVisibility(bounds.bottom > 0 && bounds.top < window.innerHeight);
          return;
        }

        autoplayObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === video) updateAutoplayVisibility(entry.isIntersecting);
          });
        });
        autoplayObserver.observe(video);
      };

      const updateState = () => {
        const isPlaying = !video.paused && !video.ended;
        if (isPlaying) hasStarted = true;
        section.classList.toggle('is-playing', isPlaying);
        section.classList.toggle('has-started', hasStarted);
        if (toggle) {
          const label = isPlaying ? pauseLabel : playLabel;
          toggle.setAttribute('aria-label', label);
          toggle.setAttribute('aria-pressed', String(isPlaying));
          if (toggleText) toggleText.textContent = label;
        }
      };

      if (toggle) {
        toggle.addEventListener('click', () => {
          if (video.paused) {
            if (!video.currentSrc && hasPlayableSource()) video.load();
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      video.addEventListener('play', updateState);
      video.addEventListener('pause', updateState);
      video.addEventListener('ended', updateState);
      video.addEventListener('loadstart', requestAutoplay);
      video.addEventListener('loadeddata', requestAutoplay);

      observeAutoplay();
      requestAutoplay();

      updateState();

      const onSectionUnload = (event) => {
        if (event.target !== section) return;
        autoplayObserver?.disconnect();
        document.removeEventListener('shopify:section:unload', onSectionUnload);
      };
      document.addEventListener('shopify:section:unload', onSectionUnload);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vep-story]');
    if (!sections.length) return;

    const reveal = (items) => {
      items.forEach((item) => item.classList.add('is-visible'));
    };

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => reveal(section.querySelectorAll('[data-vep-story-reveal]')));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16 });

    sections.forEach((section) => {
      section.querySelectorAll('[data-vep-story-reveal]').forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-calculator-tools"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const sections = document.querySelectorAll('[data-vep-calculator]');
      if (!sections.length) return;
      const core = window.VepPetTools;
      if (!core || !window.EcomIcon) return;

    const round = (value, digits = 0) => {
      const factor = 10 ** digits;
      return Math.round(value * factor) / factor;
    };

    const iconSvg = (name) => window.EcomIcon.render(name, { className: 'material-icon' });

    const getRadio = (section, field) => {
      const input = section.querySelector(`input[data-field="${field}"]:checked`);
      return input ? input.value : '';
    };

    const getValue = (section, field) => {
      const input = section.querySelector(`[data-field="${field}"]`);
      return input ? input.value : '';
    };

    const planItem = (icon, title, text) => `
      <div class="vep-calc__plan-item">
        <span class="vep-calc__plan-icon" aria-hidden="true">${iconSvg(icon)}</span>
        <div><strong>${title}</strong><span>${text}</span></div>
      </div>
    `;

    const dogFood = (profile) => {
      const result = core.dogFood(profile);
      if (!result) return null;
      return {
        ...result,
        plan: result.plan.map((item) => planItem(item.icon, item.title, item.text))
      };
    };

    const dogExercise = (profile) => {
      const result = core.dogExercise(profile);
      return {
        ...result,
        plan: result.plan.map((item) => planItem(item.icon, item.title, item.text))
      };
    };

    const catExercise = (profile) => {
      const result = core.catExercise(profile);
      return {
        ...result,
        plan: result.plan.map((item) => planItem(item.icon, item.title, item.text))
      };
    };

    const render = (section, result) => {
      const mode = section.dataset.calculatorMode;
      const primary = section.querySelector('[data-result-primary]');
      const unit = section.querySelector('.vep-calc__result-number small');
      const summary = section.querySelector('[data-result-summary]');
      const context = section.querySelector('[data-result-context]');
      const plan = section.querySelector('[data-result-plan]');
      const note = section.querySelector('[data-result-note]');
      const basis = section.querySelector('[data-result-basis]');
      const ring = section.querySelector('[data-result-ring]');
      const heroMetrics = section.querySelectorAll('[data-hero-metric]');

      if (!result) {
        primary.textContent = '0';
        unit.textContent = mode === 'dog_food' ? 'kcal/day' : 'min/day';
        summary.textContent = mode === 'dog_food' ? 'Enter a valid weight and food calorie value to see the estimate.' : 'Enter a valid profile to see the estimate.';
        context.textContent = mode === 'dog_food' ? 'Weight and label calories must both be greater than zero.' : 'Review the profile fields and try again.';
        plan.innerHTML = '';
        if (basis) basis.textContent = mode === 'dog_food' ? 'A valid weight and calorie density are required before the calculator can apply the formula.' : 'A valid profile is required before the calculator can build the plan.';
        ring.style.setProperty('--score', '8%');
        section._vepLastResult = null;
        return;
      }

      primary.textContent = result.primary;
      unit.textContent = result.unit;
      summary.textContent = result.summary;
      context.textContent = result.context;
      plan.innerHTML = result.plan.join('');
      note.textContent = result.note;
      if (basis) basis.textContent = result.basis || 'The result combines age, current condition, routine, and the inputs shown in the form.';
      ring.style.setProperty('--score', `${result.score}%`);
      heroMetrics.forEach((metric, index) => {
        metric.textContent = result.hero[index] || metric.textContent;
      });
      section._vepLastResult = result;
    };

    const calculate = (section) => {
      const mode = section.dataset.calculatorMode;
      const fallbackName = mode === 'cat_exercise' ? 'Your cat' : 'Your dog';
      const profile = {
        name: getValue(section, 'petName') || fallbackName,
        breedGroup: getValue(section, 'breedGroup'),
        age: Number(getValue(section, 'age')) || 0,
        currentWeight: Number(getValue(section, 'currentWeight')) || 0,
        targetWeight: Number(getValue(section, 'targetWeight')) || 0,
        weightBasis: getRadio(section, 'weightBasis') || 'current',
        unit: getRadio(section, 'unit') || 'lb',
        lifeStage: getValue(section, 'lifeStage'),
        neuterStatus: getValue(section, 'neuterStatus'),
        activity: getRadio(section, 'activity') || 'medium',
        condition: getRadio(section, 'condition') || 'ideal',
        goal: getValue(section, 'goal'),
        currentMinutes: getValue(section, 'currentMinutes'),
        foodUnit: getValue(section, 'foodUnit'),
        foodCalories: getValue(section, 'foodCalories'),
        meals: getValue(section, 'meals'),
        treatPercent: getValue(section, 'treatPercent'),
        careStatus: getValue(section, 'careStatus'),
        routine: getValue(section, 'routine'),
        comfort: getValue(section, 'comfort'),
        weather: getValue(section, 'weather'),
        playStyle: getValue(section, 'playStyle'),
        resources: getValue(section, 'resources'),
        sessionMinutes: getValue(section, 'sessionMinutes')
      };

      if (mode === 'dog_food') return dogFood(profile);
      if (mode === 'cat_exercise') return catExercise(profile);
      return dogExercise(profile);
    };

    const updateRangeOutputs = (section) => {
      section.querySelectorAll('input[type="range"][data-field]').forEach((input) => {
        const output = section.querySelector(`[data-range-output="${input.dataset.field}"]`);
        if (!output) return;
        const value = Number(input.value);
        output.textContent = `${round(value, value < 1 ? 1 : 0)} yr`;
      });
    };

    const update = (section, withLoading = false) => {
      updateRangeOutputs(section);
      const run = () => render(section, calculate(section));
      if (!withLoading) {
        run();
        return;
      }
      section.classList.add('is-loading');
      window.setTimeout(() => {
        run();
        section.classList.remove('is-loading');
      }, 360);
    };

    const storageKey = (section) => {
      const version = section.dataset.calculatorMode === 'dog_exercise' ? 'v1' : 'v2';
      return `vep-pet-tool:${section.dataset.calculatorMode}:${version}`;
    };

    const setActionStatus = (section, message) => {
      const status = section.querySelector('[data-action-status]');
      if (status) status.textContent = message;
    };

    const resultText = (section) => {
      const title = section.querySelector('.vep-calc__title')?.textContent.trim() || 'Pet care plan';
      const primary = section.querySelector('[data-result-primary]')?.textContent.trim() || '';
      const unit = section.querySelector('.vep-calc__result-number small')?.textContent.trim() || '';
      const summary = section.querySelector('[data-result-summary]')?.textContent.trim() || '';
      const basis = section.querySelector('[data-result-basis]')?.textContent.trim() || '';
      const note = section.querySelector('[data-result-note]')?.textContent.trim() || '';
      const plan = Array.from(section.querySelectorAll('.vep-calc__plan-item')).map((item) => {
        const heading = item.querySelector('strong')?.textContent.trim() || '';
        const text = item.querySelector('div > span')?.textContent.trim() || '';
        return `${heading}: ${text}`;
      });
      return [title, `${primary} ${unit}`.trim(), summary, '', ...plan, '', `Why this result: ${basis}`, note].filter((line) => line !== '').join('\n');
    };

    const restoreSaved = (section, form) => {
      try {
        const saved = window.localStorage.getItem(storageKey(section));
        if (!saved) return false;
        core.restoreForm(form, JSON.parse(saved));
        setActionStatus(section, 'Restored the plan saved in this browser.');
        return true;
      } catch (error) {
        return false;
      }
    };

    const bindResultActions = (section, form) => {
      section.querySelectorAll('[data-result-action]').forEach((button) => {
        button.addEventListener('click', async () => {
          const action = button.dataset.resultAction;
          if (action === 'copy') {
            try {
              const copied = await core.copyText(resultText(section));
              setActionStatus(section, copied ? 'Plan copied.' : 'Copy is not available in this browser.');
              if (copied) core.track(section.dataset.calculatorMode, 'copy');
            } catch (error) {
              setActionStatus(section, 'Copy is not available in this browser.');
            }
            return;
          }
          if (action === 'save') {
            try {
              window.localStorage.setItem(storageKey(section), JSON.stringify(core.captureForm(form)));
              setActionStatus(section, 'Saved in this browser only.');
              core.track(section.dataset.calculatorMode, 'save');
            } catch (error) {
              setActionStatus(section, 'This browser did not allow local saving.');
            }
            return;
          }
          if (action === 'print') {
            const cleanup = () => document.body.classList.remove('vep-calc-printing');
            document.body.classList.add('vep-calc-printing');
            window.addEventListener('afterprint', cleanup, { once: true });
            window.setTimeout(cleanup, 10000);
            core.track(section.dataset.calculatorMode, 'print');
            window.print();
          }
        });
      });
    };

    const reveal = (section) => {
      const items = section.querySelectorAll('[data-vep-calc-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      items.forEach((item) => observer.observe(item));
    };

      sections.forEach((section) => {
      const form = section.querySelector('[data-calc-form]');
      const reset = section.querySelector('[data-calc-reset]');
      if (!form) return;
      let started = false;

      restoreSaved(section, form);
      bindResultActions(section, form);

      const change = () => {
        if (!started) {
          core.track(section.dataset.calculatorMode, 'start');
          started = true;
        }
        update(section);
      };
      form.addEventListener('input', change);
      form.addEventListener('change', change);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        update(section, true);
        core.track(section.dataset.calculatorMode, 'result');
      });

      if (reset) {
        reset.addEventListener('click', () => {
          form.reset();
          try {
            window.localStorage.removeItem(storageKey(section));
          } catch (error) {
          }
          setActionStatus(section, 'Inputs and the saved browser plan were reset.');
          core.track(section.dataset.calculatorMode, 'reset');
          update(section, true);
        });
      }

      reveal(section);
      update(section);
      });
    };

    if (window.VepPetTools) {
      initialize();
    } else {
      window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-tools-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-tools-hub]').forEach((hub) => {
      const filters = Array.from(hub.querySelectorAll('[data-tool-filter]'));
      const cards = Array.from(hub.querySelectorAll('[data-tool-card]'));
      const count = hub.querySelector('[data-tool-count]');
      if (!filters.length || !cards.length) return;

      const show = (category) => {
        let visible = 0;
        cards.forEach((card) => {
          const matches = category === 'all' || card.dataset.category === category;
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.toolFilter === category)));
        if (count) count.textContent = category === 'all' ? 'Showing all 10 tools' : `Showing ${visible} ${visible === 1 ? 'tool' : 'tools'}`;
      };

      filters.forEach((button) => button.addEventListener('click', () => show(button.dataset.toolFilter)));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-editorial-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vep-support-page]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => {
        section.querySelectorAll('[data-vep-support-reveal]').forEach((item) => item.classList.add('is-visible'));
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    sections.forEach((section) => {
      section.querySelectorAll('[data-vep-support-reveal]').forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-cat-enrichment-routine-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const core = window.VepPetTools;
      if (!core || typeof core.catEnrichment !== 'function') return;
      document.querySelectorAll('[data-cat-enrichment-tool]').forEach((tool) => {
        if (tool.dataset.ready === 'true') return;
        tool.dataset.ready = 'true';
        const form = tool.querySelector('[data-tool-form]');
        const storageKey = 'vep-cat-enrichment-v2';
        const progress = new Set();
        const resourceValues = () => Array.from(form.querySelectorAll('[data-resource]:checked')).map((input) => input.value);
        const profile = () => Object.assign(core.captureForm(form), { resources: resourceValues() });
        const setStatus = (message) => { tool.querySelector('[data-action-status]').textContent = message; };
        const payload = () => ({ form: core.captureForm(form), resources: resourceValues(), progress: Array.from(progress) });
        const save = (message = '') => {
          try { localStorage.setItem(storageKey, JSON.stringify(payload())); if (message) setStatus(message); return true; }
          catch (error) { setStatus('This browser could not save the routine. Copy or print it instead.'); return false; }
        };
        const restore = () => {
          try {
            const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
            if (!saved) return false;
            core.restoreForm(form, saved.form || {});
            const selected = Array.isArray(saved.resources) ? saved.resources : [];
            form.querySelectorAll('[data-resource]').forEach((input) => { input.checked = selected.includes(input.value); });
            (Array.isArray(saved.progress) ? saved.progress : []).forEach((id) => progress.add(id));
            return true;
          } catch (error) { return false; }
        };
        const updateProgress = () => {
          const total = 7;
          const completed = progress.size;
          tool.querySelector('[data-progress-fill]').style.width = Math.round((completed / total) * 100) + '%';
          tool.querySelector('[data-progress-text]').textContent = completed + ' of ' + total + ' days checked';
        };
        const render = () => {
          const result = core.catEnrichment(profile());
          tool.querySelector('[data-result-primary]').textContent = result.primary;
          tool.querySelector('[data-result-title]').textContent = result.title;
          tool.querySelector('[data-result-copy]').textContent = result.copy;
          tool.querySelector('[data-result-basis]').textContent = result.basis;
          tool.querySelector('[data-factor-list]').innerHTML = result.factors.map((factor) => '<li>' + factor + '</li>').join('');
          tool.querySelector('[data-resource-audit]').innerHTML = result.resources.map((item) => '<article class="vep-tool__audit-item"><div class="vep-tool__item-head"><strong>' + item.title + '</strong><span class="vep-tool__item-tag" data-ready="' + item.ready + '">' + (item.ready ? 'Available' : 'Add next') + '</span></div><span class="vep-tool__item-copy">' + item.action + '</span><span class="vep-tool__budget">' + item.lowCost + '</span></article>').join('');
          tool.querySelector('[data-anchor-list]').innerHTML = result.dailyAnchors.map((item) => '<article class="vep-tool__anchor-item"><span class="vep-tool__anchor-time">' + item.time + '</span><div class="vep-tool__item-head"><strong>' + item.title + '</strong></div><span class="vep-tool__item-copy">' + item.text + '</span><span class="vep-tool__budget">' + item.lowCost + '</span></article>').join('');
          tool.querySelector('[data-week-list]').innerHTML = result.weekPlan.map((item) => '<label class="vep-tool__week-item"><input type="checkbox" data-week-id="' + item.id + '"' + (progress.has(item.id) ? ' checked' : '') + '><span><span class="vep-tool__anchor-time">' + item.day + '</span><span class="vep-tool__item-head"><strong>' + item.title + '</strong></span><span class="vep-tool__item-copy">' + item.text + '</span><span class="vep-tool__budget">' + item.lowCost + '</span></span></label>').join('');
          tool.querySelector('[data-result-note]').textContent = result.note;
          updateProgress();
          tool.dataset.copyText = [result.primary, result.title, result.copy, result.basis, '', 'Essential setup', ...result.resources.map((item) => item.title + ' (' + (item.ready ? 'available' : 'add next') + '): ' + item.action + ' ' + item.lowCost), '', 'Daily anchors', ...result.dailyAnchors.map((item) => item.time + ' - ' + item.title + ': ' + item.text + ' ' + item.lowCost), '', '7-day plan', ...result.weekPlan.map((item) => item.day + ' - ' + item.title + ': ' + item.text + ' ' + item.lowCost), '', result.note].join('\n');
          core.track('cat-enrichment', 'result');
        };

        const restored = restore();
        render();
        if (restored) setStatus('Restored the routine saved in this browser.');
        form.addEventListener('change', () => { render(); save('Updated and saved in this browser.'); core.track('cat-enrichment', 'start'); });
        form.addEventListener('input', (event) => { if (event.target.matches('input[type="number"]')) render(); });
        tool.querySelector('[data-week-list]').addEventListener('change', (event) => {
          const checkbox = event.target.closest('[data-week-id]');
          if (!checkbox) return;
          if (checkbox.checked) progress.add(checkbox.dataset.weekId); else progress.delete(checkbox.dataset.weekId);
          updateProgress(); save('Progress saved in this browser.'); core.track('cat-enrichment', 'check');
        });
        tool.querySelectorAll('[data-result-action]').forEach((button) => button.addEventListener('click', async () => {
          const action = button.dataset.resultAction;
          if (action === 'copy') { const copied = await core.copyText(tool.dataset.copyText || ''); setStatus(copied ? 'Cat enrichment routine copied.' : 'Copy was not available. Use Print instead.'); }
          if (action === 'save') save('Saved in this browser only.');
          if (action === 'print') window.print();
          if (action === 'reset') {
            form.reset(); progress.clear();
            try { localStorage.removeItem(storageKey); } catch (error) { /* No action needed. */ }
            render(); setStatus('Routine reset.');
          }
          core.track('cat-enrichment', action);
        }));
      });
    };
    if (window.VepPetTools) initialize();
    else window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-cooling-hydration-planner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const core = window.VepPetTools;
      if (!core || typeof core.coolingHydration !== 'function') return;
      document.querySelectorAll('[data-cooling-tool]').forEach((tool) => {
        if (tool.dataset.ready === 'true') return;
        tool.dataset.ready = 'true';
        const form = tool.querySelector('[data-tool-form]');
        const storageKey = 'vep-cooling-hydration-v2';
        const profile = () => core.captureForm(form);
        const setStatus = (message) => { tool.querySelector('[data-action-status]').textContent = message; };
        const save = (message = '') => {
          try { localStorage.setItem(storageKey, JSON.stringify(profile())); if (message) setStatus(message); return true; }
          catch (error) { setStatus('This browser could not save the plan. Copy or print it instead.'); return false; }
        };
        const restore = () => {
          try { const saved = JSON.parse(localStorage.getItem(storageKey) || 'null'); return saved ? core.restoreForm(form, saved) : false; }
          catch (error) { return false; }
        };
        const render = () => {
          const result = core.coolingHydration(profile());
          if (!result) { setStatus('Enter a valid temperature and body weight.'); return; }
          const card = tool.querySelector('[data-result-card]');
          card.dataset.band = result.details.band;
          tool.querySelector('[data-result-primary]').textContent = result.primary;
          tool.querySelector('[data-result-title]').textContent = result.title;
          tool.querySelector('[data-result-copy]').textContent = result.copy;
          tool.querySelector('[data-result-basis]').textContent = result.basis;
          tool.querySelector('[data-water-range]').textContent = result.waterRange;
          tool.querySelector('[data-factor-list]').innerHTML = (result.details.cautionFactors.length ? result.details.cautionFactors : ['No added caution factor selected']).map((factor) => `<li>${factor}</li>`).join('');
          tool.querySelector('[data-result-plan]').innerHTML = result.plan.map((item) => `<div class="vep-tool__plan-item"><strong>${item.title}</strong><span>${item.text}</span></div>`).join('');
          tool.querySelector('[data-result-note]').textContent = result.note;
          tool.dataset.copyText = [result.primary, result.title, result.copy, result.basis, `Water context: ${result.waterRange}`, '', ...result.plan.map((item) => `${item.title}: ${item.text}`), '', result.note].join('\n');
          core.track('cooling-hydration', 'result');
        };
        const convertTemperature = () => {
          const input = form.querySelector('[data-field="temperature"]');
          const unit = form.querySelector('[data-field="temperatureUnit"]').value;
          const previous = tool.dataset.temperatureUnit || unit;
          if (previous !== unit) {
            const value = Number(input.value);
            if (Number.isFinite(value)) input.value = unit === 'c' ? ((value - 32) * 5 / 9).toFixed(1) : (value * 9 / 5 + 32).toFixed(1);
          }
          input.min = unit === 'c' ? '0' : '32'; input.max = unit === 'c' ? '55' : '130'; input.step = unit === 'c' ? '0.5' : '1'; tool.dataset.temperatureUnit = unit;
        };
        const convertWeight = () => {
          const input = form.querySelector('[data-field="weight"]');
          const unit = form.querySelector('[data-field="weightUnit"]').value;
          const previous = tool.dataset.weightUnit || unit;
          if (previous !== unit) {
            const value = Number(input.value);
            if (Number.isFinite(value)) input.value = unit === 'kg' ? (value / 2.20462).toFixed(1) : (value * 2.20462).toFixed(1);
          }
          input.min = unit === 'kg' ? '0.5' : '1'; input.max = unit === 'kg' ? '115' : '250'; tool.dataset.weightUnit = unit;
        };

        const restored = restore();
        tool.dataset.temperatureUnit = form.querySelector('[data-field="temperatureUnit"]').value;
        tool.dataset.weightUnit = form.querySelector('[data-field="weightUnit"]').value;
        convertTemperature(); convertWeight(); render();
        if (restored) setStatus('Restored the plan saved in this browser.');
        form.addEventListener('change', (event) => {
          if (event.target.matches('[data-field="temperatureUnit"]')) convertTemperature();
          if (event.target.matches('[data-field="weightUnit"]')) convertWeight();
          render(); save('Updated and saved in this browser.'); core.track('cooling-hydration', 'start');
        });
        form.addEventListener('input', (event) => { if (event.target.matches('input')) render(); });
        tool.querySelectorAll('[data-result-action]').forEach((button) => button.addEventListener('click', async () => {
          const action = button.dataset.resultAction;
          if (action === 'copy') { const copied = await core.copyText(tool.dataset.copyText || ''); setStatus(copied ? 'Cooling plan copied.' : 'Copy was not available. Use Print instead.'); }
          if (action === 'save') save('Saved in this browser only.');
          if (action === 'print') window.print();
          core.track('cooling-hydration', action);
        }));
      });
    };
    if (window.VepPetTools) initialize();
    else window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-feeding-transition-planner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const core = window.VepPetTools;
      if (!core) return;
      document.querySelectorAll('[data-feeding-transition-tool]').forEach((tool) => {
        if (tool.dataset.initialized === 'true') return;
        tool.dataset.initialized = 'true';
        const form = tool.querySelector('[data-tool-form]');
        const storageKey = 'vep-feeding-transition-v2';
        const state = { activeDay: 1, holdCount: 0, history: [] };
        let result = null;
        const now = new Date();
        const today = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
        const setStatus = (message) => { tool.querySelector('[data-action-status]').textContent = message; };
        const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character]));
        const observationLabels = {
          stool: { normal: 'usual stool', soft: 'soft stool', liquid: 'liquid diarrhea', none: 'no stool observed', blood: 'blood or black stool' },
          appetite: { normal: 'usual appetite', lower: 'lower appetite', refused: 'food refused', higher: 'higher appetite' }
        };
        const payload = () => ({ form: core.captureForm(form), activeDay: state.activeDay, holdCount: state.holdCount, history: state.history.slice(0, 20) });
        const save = (message = '') => {
          try { localStorage.setItem(storageKey, JSON.stringify(payload())); if (message) setStatus(message); return true; }
          catch (error) { setStatus('This browser could not save the plan. Copy or print it instead.'); return false; }
        };
        const restore = () => {
          try {
            const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
            if (!saved) return false;
            core.restoreForm(form, saved.form || {});
            state.activeDay = Math.max(1, Math.trunc(Number(saved.activeDay) || 1));
            state.holdCount = Math.max(0, Math.trunc(Number(saved.holdCount) || 0));
            if (Array.isArray(saved.history)) state.history = saved.history.slice(0, 20).map((entry) => ({ date: String(entry.date || ''), day: Math.max(1, Math.trunc(Number(entry.day) || 1)), ratio: String(entry.ratio || ''), stool: String(entry.stool || 'normal'), appetite: String(entry.appetite || 'normal'), note: String(entry.note || '').slice(0, 240) }));
            return true;
          } catch (error) { return false; }
        };
        const profile = () => Object.assign(core.captureForm(form), { activeDay: state.activeDay, holdCount: state.holdCount });
        const renderHistory = () => {
          const list = tool.querySelector('[data-history-list]');
          if (!state.history.length) { list.innerHTML = '<p class="vep-tool__history-copy">No check-in saved yet.</p>'; return; }
          list.innerHTML = state.history.slice(0, 5).map((entry) => '<article class="vep-tool__history-item"><strong>' + escapeHtml(entry.date) + ' · Day ' + entry.day + ' · ' + escapeHtml(entry.ratio) + '</strong><p class="vep-tool__history-copy">' + escapeHtml(observationLabels.stool[entry.stool] || entry.stool) + '; ' + escapeHtml(observationLabels.appetite[entry.appetite] || entry.appetite) + (entry.note ? '; ' + escapeHtml(entry.note) : '') + '</p></article>').join('');
        };
        const renderMode = () => {
          const mode = form.querySelector('[data-field="amountMode"]').value;
          tool.querySelectorAll('[data-mode-panel]').forEach((panel) => { panel.hidden = panel.dataset.modePanel !== mode; });
          ['old', 'new'].forEach((side) => {
            const unit = form.querySelector('[data-field="' + side + 'Unit"]').value;
            const hint = tool.querySelector('[data-density-hint="' + side + '"]');
            if (!hint) return;
            hint.textContent = unit === 'gram' || unit === 'ounce' ? 'Enter kcal/kg from the label.' : 'Enter kcal per ' + unit + '.';
          });
        };
        const render = () => {
          renderMode();
          result = core.feedingTransition(profile());
          state.activeDay = result.details.activeDay;
          state.holdCount = result.details.holdCount;
          const card = tool.querySelector('[data-result-card]');
          card.dataset.alerts = result.alerts.length ? 'true' : 'false';
          tool.querySelector('[data-result-primary]').textContent = result.primary;
          tool.querySelector('[data-result-title]').textContent = result.title;
          tool.querySelector('[data-result-copy]').textContent = result.copy;
          tool.querySelector('[data-result-basis]').textContent = result.basis;
          tool.querySelector('[data-factor-list]').innerHTML = result.factors.map((factor) => '<li>' + factor + '</li>').join('');
          const alerts = tool.querySelector('[data-alert-list]');
          alerts.hidden = !result.alerts.length;
          alerts.innerHTML = result.alerts.map((alert) => '<div class="vep-tool__alert">' + alert + '</div>').join('');
          tool.querySelector('[data-metric-days]').textContent = result.details.days + ' days';
          tool.querySelector('[data-metric-calories]').textContent = result.details.targetCalories === null ? 'Not verified' : 'About ' + Math.round(result.details.targetCalories) + ' kcal/day';
          tool.querySelector('[data-metric-old]').textContent = result.details.oldFullText || 'Add amount';
          tool.querySelector('[data-metric-new]').textContent = result.details.newFullText || 'Add amount';
          const activeCard = tool.querySelector('[data-active-card]');
          activeCard.hidden = !result.active;
          if (result.active) {
            tool.querySelector('[data-active-day]').textContent = 'Active day ' + result.active.day + (state.holdCount ? ' · held ' + state.holdCount + ' extra day' + (state.holdCount === 1 ? '' : 's') : '');
            tool.querySelector('[data-active-ratio]').textContent = result.active.oldPercent + '% old, ' + result.active.newPercent + '% new';
            tool.querySelector('[data-active-old]').textContent = result.active.oldDailyText;
            tool.querySelector('[data-active-new]').textContent = result.active.newDailyText;
            tool.querySelector('[data-active-old-meal]').textContent = result.active.oldPerMealText + ' per meal';
            tool.querySelector('[data-active-new-meal]').textContent = result.active.newPerMealText + ' per meal';
            tool.querySelector('[data-active-check]').textContent = result.active.check;
            tool.querySelector('[data-active-action]').textContent = result.action;
            tool.querySelector('[data-presentation-note]').textContent = result.presentationNote;
          }
          const symptomLevel = form.querySelector('[data-field="symptoms"]').value;
          const unsafeToUseControls = ['concerning', 'urgent'].includes(symptomLevel) || !result.details.valid;
          const unsafeScheduleSelection = ['mild', 'concerning', 'urgent'].includes(symptomLevel) || !result.details.valid;
          tool.querySelector('[data-repeat-day]').disabled = unsafeToUseControls;
          tool.querySelector('[data-next-day]').disabled = unsafeToUseControls || symptomLevel === 'mild' || state.activeDay >= result.details.days;
          tool.querySelector('[data-schedule-list]').innerHTML = result.schedule.length ? result.schedule.map((row) => '<li class="vep-tool__schedule-item" data-schedule-day="' + row.day + '"><span class="vep-tool__day">Day ' + row.day + '</span><div class="vep-tool__schedule-main"><strong>' + row.oldPercent + '% old · ' + row.newPercent + '% new</strong><span>Daily: ' + row.oldDailyText + ' old + ' + row.newDailyText + ' new</span><span>Per meal: ' + row.oldPerMealText + ' old + ' + row.newPerMealText + ' new</span><p class="vep-tool__schedule-check">' + row.check + '</p></div><button type="button" class="vep-tool__small-button" data-use-day="' + row.day + '">Use day ' + row.day + '</button></li>').join('') : '<li class="vep-tool__schedule-item"><div class="vep-tool__schedule-main"><strong>Add valid amounts to build the chart.</strong><p class="vep-tool__schedule-check">The planner will not invent missing portions.</p></div></li>';
          tool.querySelectorAll('[data-use-day]').forEach((button) => { button.disabled = unsafeScheduleSelection; });
          tool.querySelector('[data-result-note]').textContent = result.note;
          const historyText = state.history.map((entry) => entry.date + ' · Day ' + entry.day + ' · ' + entry.ratio + ' · ' + (observationLabels.stool[entry.stool] || entry.stool) + ' · ' + (observationLabels.appetite[entry.appetite] || entry.appetite) + (entry.note ? ' · ' + entry.note : ''));
          tool.dataset.copyText = [result.primary, result.title, result.copy, result.basis, '', ...result.alerts.map((alert) => 'Priority: ' + alert), '', result.active ? 'Active day ' + result.active.day + ': ' + result.active.oldPercent + '% old, ' + result.active.newPercent + '% new. ' + result.active.oldDailyText + ' old and ' + result.active.newDailyText + ' new for the day. ' + result.active.oldPerMealText + ' old and ' + result.active.newPerMealText + ' new per meal.' : '', '', ...result.schedule.map((row) => 'Day ' + row.day + ': ' + row.oldPercent + '% old, ' + row.newPercent + '% new. Daily ' + row.oldDailyText + ' old + ' + row.newDailyText + ' new. Per meal ' + row.oldPerMealText + ' old + ' + row.newPerMealText + ' new.'), '', ...historyText, '', result.note].join('\n');
          renderHistory();
          core.track('feeding-transition', 'result');
        };

        const restored = restore();
        render();
        if (restored) setStatus('Restored the transition saved in this browser.');
        form.addEventListener('input', () => { render(); save(); core.track('feeding-transition', 'start'); });
        tool.querySelector('[data-repeat-day]').addEventListener('click', () => { state.holdCount += 1; render(); save('Kept this ratio for another day.'); core.track('feeding-transition', 'repeat'); });
        tool.querySelector('[data-next-day]').addEventListener('click', () => { state.activeDay = Math.min(state.activeDay + 1, result.details.days); state.holdCount = 0; render(); save('Moved to the next planned day.'); core.track('feeding-transition', 'advance'); });
        tool.querySelector('[data-schedule-list]').addEventListener('click', (event) => {
          const button = event.target.closest('[data-use-day]');
          if (!button) return;
          const symptomLevel = form.querySelector('[data-field="symptoms"]').value;
          if (['mild', 'concerning', 'urgent'].includes(symptomLevel) || !result.details.valid) {
            setStatus('Resolve the current symptom guidance before selecting another planned day.');
            return;
          }
          state.activeDay = Number(button.dataset.useDay) || 1;
          state.holdCount = 0;
          render();
          save('Day ' + state.activeDay + ' is now active.');
          core.track('feeding-transition', 'select-day');
        });
        tool.querySelector('[data-save-checkin]').addEventListener('click', () => {
          if (!result.active) { setStatus('Add valid food amounts before saving a check-in.'); return; }
          const stool = tool.querySelector('[data-observation-field="stool"]').value;
          const appetite = tool.querySelector('[data-observation-field="appetite"]').value;
          const note = tool.querySelector('[data-observation-field="note"]').value.trim().slice(0, 240);
          state.history.unshift({ date: today, day: state.activeDay, ratio: result.active.oldPercent + '% old / ' + result.active.newPercent + '% new', stool, appetite, note });
          state.history = state.history.slice(0, 20);
          tool.querySelector('[data-observation-field="note"]').value = '';
          renderHistory();
          save('Check-in saved in this browser.');
          core.track('feeding-transition', 'check-in');
        });
        tool.querySelectorAll('[data-result-action]').forEach((button) => button.addEventListener('click', async () => {
          const action = button.dataset.resultAction;
          if (action === 'copy') { const copied = await core.copyText(tool.dataset.copyText || ''); setStatus(copied ? 'Food transition plan copied.' : 'Copy was not available. Use Print instead.'); }
          if (action === 'save') save('Saved in this browser only.');
          if (action === 'print') window.print();
          if (action === 'reset') { form.reset(); state.activeDay = 1; state.holdCount = 0; state.history = []; try { localStorage.removeItem(storageKey); } catch (error) { /* No action needed. */ } render(); setStatus('Transition plan reset.'); }
          core.track('feeding-transition', action);
        }));
      });
    };
    if (window.VepPetTools) initialize();
    else window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-grooming-routine-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const core = window.VepPetTools;
      if (!core || typeof core.groomingRoutine !== 'function') return;
      document.querySelectorAll('[data-grooming-tool]').forEach((tool) => {
        if (tool.dataset.ready === 'true') return;
        tool.dataset.ready = 'true';
        const form = tool.querySelector('[data-tool-form]');
        const storageKey = 'vep-grooming-routine-v2';
        const completed = {};
        const now = new Date();
        const today = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
        const profile = () => Object.assign(core.captureForm(form), { today, completed: Object.assign({}, completed) });
        const setStatus = (message) => { tool.querySelector('[data-action-status]').textContent = message; };
        const payload = () => ({ form: core.captureForm(form), completed: Object.assign({}, completed) });
        const save = (message = '') => {
          try { localStorage.setItem(storageKey, JSON.stringify(payload())); if (message) setStatus(message); return true; }
          catch (error) { setStatus('This browser could not save the routine. Copy or print it instead.'); return false; }
        };
        const restore = () => {
          try {
            const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
            if (!saved) return false;
            core.restoreForm(form, saved.form || {});
            Object.entries(saved.completed || {}).forEach(([id, value]) => { if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) completed[id] = value; });
            return true;
          } catch (error) { return false; }
        };
        const render = () => {
          const result = core.groomingRoutine(profile());
          const card = tool.querySelector('[data-result-card]');
          card.dataset.alerts = result.alerts.length ? 'true' : 'false';
          tool.querySelector('[data-result-primary]').textContent = result.primary;
          tool.querySelector('[data-result-title]').textContent = result.title;
          tool.querySelector('[data-result-copy]').textContent = result.copy;
          tool.querySelector('[data-result-basis]').textContent = result.basis;
          tool.querySelector('[data-factor-list]').innerHTML = result.factors.map((factor) => '<li>' + factor + '</li>').join('');
          const alertList = tool.querySelector('[data-alert-list]');
          alertList.hidden = !result.alerts.length;
          alertList.innerHTML = result.alerts.map((alert) => '<div class="vep-tool__alert">' + alert + '</div>').join('');
          tool.querySelector('[data-progress-fill]').style.width = Math.round((result.details.completedCount / result.tasks.length) * 100) + '%';
          tool.querySelector('[data-progress-text]').textContent = result.details.completedCount + ' of ' + result.tasks.length + ' tasks dated';
          tool.querySelector('[data-task-list]').innerHTML = result.tasks.map((task) => '<article class="vep-tool__task" data-task-id="' + task.id + '"><div class="vep-tool__task-head"><strong>' + task.title + '</strong><span class="vep-tool__task-status">' + task.status + '</span></div><span class="vep-tool__task-cadence">' + task.cadence + '</span><span class="vep-tool__task-copy">' + task.action + '</span><span class="vep-tool__task-stop">When to stop: ' + task.stop + '</span><div class="vep-tool__task-controls"><label class="vep-tool__date-label">Last completed<input type="date" value="' + task.lastCompleted + '" max="' + today + '" data-completed-id="' + task.id + '" aria-label="Last completed: ' + task.title + '"></label><button class="vep-tool__mark-button" type="button" data-mark-today="' + task.id + '">Mark done today</button></div></article>').join('');
          tool.querySelector('[data-result-note]').textContent = result.note;
          tool.dataset.copyText = [result.primary, result.title, result.copy, result.basis, '', ...result.alerts.map((alert) => 'Priority: ' + alert), '', ...result.tasks.map((task) => task.title + ' - ' + task.status + '. ' + task.cadence + '. ' + task.action + ' When to stop: ' + task.stop), '', result.note].join('\n');
          core.track('grooming-routine', 'result');
        };

        const restored = restore();
        render();
        if (restored) setStatus('Restored the routine saved in this browser.');
        form.addEventListener('change', () => { render(); save('Updated and saved in this browser.'); core.track('grooming-routine', 'start'); });
        tool.querySelector('[data-task-list]').addEventListener('change', (event) => {
          const input = event.target.closest('[data-completed-id]');
          if (!input) return;
          if (input.value) completed[input.dataset.completedId] = input.value; else delete completed[input.dataset.completedId];
          render(); save('Completion date saved in this browser.'); core.track('grooming-routine', 'date');
        });
        tool.querySelector('[data-task-list]').addEventListener('click', (event) => {
          const button = event.target.closest('[data-mark-today]');
          if (!button) return;
          completed[button.dataset.markToday] = today;
          render(); save('Marked complete today.'); core.track('grooming-routine', 'complete');
        });
        tool.querySelectorAll('[data-result-action]').forEach((button) => button.addEventListener('click', async () => {
          const action = button.dataset.resultAction;
          if (action === 'copy') { const copied = await core.copyText(tool.dataset.copyText || ''); setStatus(copied ? 'Grooming routine copied.' : 'Copy was not available. Use Print instead.'); }
          if (action === 'save') save('Saved in this browser only.');
          if (action === 'print') window.print();
          if (action === 'reset') { form.reset(); Object.keys(completed).forEach((id) => delete completed[id]); try { localStorage.removeItem(storageKey); } catch (error) { /* No action needed. */ } render(); setStatus('Routine reset.'); }
          core.track('grooming-routine', action);
        }));
      });
    };
    if (window.VepPetTools) initialize();
    else window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-senior-pet-mobility-checker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const tools = document.querySelectorAll('[data-mobility-tool]');
      if (!tools.length || !window.VepPetTools) return;
      const core = window.VepPetTools;

      const get = (tool, field) => {
        const input = tool.querySelector(`[data-field="${field}"]`);
        return input ? input.value : '';
      };

      const profile = (tool) => ({
        name: get(tool, 'name'),
        species: get(tool, 'species'),
        checkDate: get(tool, 'checkDate'),
        repeatDays: get(tool, 'repeatDays'),
        rising: get(tool, 'rising'),
        lyingDown: get(tool, 'lyingDown'),
        balance: get(tool, 'balance'),
        walking: get(tool, 'walking'),
        stairs: get(tool, 'stairs'),
        slipping: get(tool, 'slipping'),
        comfort: get(tool, 'comfort'),
        sleep: get(tool, 'sleep'),
        favorite: get(tool, 'favorite'),
        urgent: get(tool, 'urgent')
      });

      const planItem = (item) => `<div class="vep-tool__plan-item"><strong>${item.title}</strong><span>${item.text}</span></div>`;

      const update = (tool) => {
        const result = core.seniorMobility(profile(tool));
        tool.querySelector('[data-result-primary]').textContent = result.primary;
        tool.querySelector('[data-result-unit]').textContent = result.unit;
        tool.querySelector('[data-result-title]').textContent = result.title;
        tool.querySelector('[data-result-copy]').textContent = result.copy;
        tool.querySelector('[data-result-plan]').innerHTML = result.plan.map(planItem).join('');
        tool.querySelector('[data-result-basis]').textContent = `Why this result: ${result.basis}`;
        tool.querySelector('[data-result-note]').textContent = result.note;
        tool._vepLastResult = result;
      };

      const setStatus = (tool, text) => {
        const status = tool.querySelector('[data-action-status]');
        if (status) status.textContent = text;
      };

      const resultText = (tool) => {
        const heading = tool.querySelector('.vep-tool__title')?.textContent.trim() || 'Senior Pet Mobility Checker';
        const title = tool.querySelector('[data-result-title]')?.textContent.trim() || '';
        const primary = tool.querySelector('[data-result-primary]')?.textContent.trim() || '';
        const copy = tool.querySelector('[data-result-copy]')?.textContent.trim() || '';
        const plan = Array.from(tool.querySelectorAll('.vep-tool__plan-item')).map((item) => item.innerText.trim());
        const basis = tool.querySelector('[data-result-basis]')?.textContent.trim() || '';
        const note = tool.querySelector('[data-result-note]')?.textContent.trim() || '';
        return [heading, title, primary, copy, '', ...plan, '', basis, note].filter(Boolean).join('\n');
      };

      tools.forEach((tool) => {
        if (tool.dataset.toolInitialized === 'true') return;
        tool.dataset.toolInitialized = 'true';
        const form = tool.querySelector('[data-tool-form]');
        const storageKey = 'vep-pet-tool:senior-mobility:v2';
        try {
          const saved = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
          if (saved) core.restoreForm(form, saved);
        } catch (error) {
          window.localStorage.removeItem(storageKey);
        }
        form.addEventListener('input', () => update(tool));
        form.addEventListener('change', () => update(tool));
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          update(tool);
          core.track('senior_mobility', 'calculate');
        });
        form.addEventListener('reset', () => window.setTimeout(() => {
          setStatus(tool, '');
          update(tool);
        }));
        tool.querySelectorAll('[data-result-action]').forEach((button) => {
          button.addEventListener('click', async () => {
            const action = button.dataset.resultAction;
            if (action === 'copy') {
              const copied = await core.copyText(resultText(tool));
              setStatus(tool, copied ? 'Summary copied.' : 'Copy is unavailable in this browser.');
            }
            if (action === 'save') {
              window.localStorage.setItem(storageKey, JSON.stringify(core.captureForm(form)));
              setStatus(tool, 'Saved in this browser only.');
            }
            if (action === 'print') window.print();
            core.track('senior_mobility', action);
          });
        });
        update(tool);
      });
    };

    if (window.VepPetTools) {
      initialize();
    } else {
      window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-size-fit-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const tools = document.querySelectorAll('[data-size-fit-tool]');
      if (!tools.length || !window.VepPetTools || !window.EcomIcon) return;
      const core = window.VepPetTools;

      const iconSvg = (name) => window.EcomIcon.render(name, { className: 'material-icon' });

      const getValue = (tool, field) => {
        const checked = tool.querySelector(`[data-field="${field}"]:checked`);
        if (checked) return checked.value;
        const input = tool.querySelector(`[data-field="${field}"]`);
        return input ? input.value : '';
      };

      const planItem = (item) => `
        <div class="vep-tool__plan-item">
          <span class="vep-tool__plan-icon" aria-hidden="true">${iconSvg(item.icon)}</span>
          <div><strong>${item.title}</strong><span>${item.text}</span></div>
        </div>
      `;

      const profile = (tool) => ({
        name: getValue(tool, 'name'),
        species: getValue(tool, 'species'),
        unit: getValue(tool, 'unit'),
        mode: getValue(tool, 'mode'),
        neck: getValue(tool, 'neck'),
        chest: getValue(tool, 'chest'),
        backLength: getValue(tool, 'backLength'),
        sleepingLength: getValue(tool, 'sleepingLength'),
        sleepingWidth: getValue(tool, 'sleepingWidth'),
        sleepStyle: getValue(tool, 'sleepStyle'),
        travelType: getValue(tool, 'travelType'),
        travelA: getValue(tool, 'travelA'),
        travelB: getValue(tool, 'travelB'),
        travelC: getValue(tool, 'travelC'),
        travelD: getValue(tool, 'travelD'),
        accessHeight: getValue(tool, 'accessHeight'),
        availableRun: getValue(tool, 'availableRun'),
        mobilityComfort: getValue(tool, 'mobilityComfort')
      });

      const setGroups = (tool) => {
        const mode = getValue(tool, 'mode');
        tool.querySelectorAll('[data-mode-group]').forEach((group) => {
          group.hidden = group.dataset.modeGroup !== mode;
        });
      };

      const update = (tool) => {
        setGroups(tool);
        const result = core.sizeFit(profile(tool));
        const title = tool.querySelector('[data-result-title]');
        const primary = tool.querySelector('[data-result-primary]');
        const unit = tool.querySelector('[data-result-unit]');
        const copy = tool.querySelector('[data-result-copy]');
        const plan = tool.querySelector('[data-result-plan]');
        const basis = tool.querySelector('[data-result-basis]');
        const note = tool.querySelector('[data-result-note]');
        if (!result) {
          title.textContent = 'Complete the measurements for this fit mode';
          primary.textContent = 'Measurements needed';
          unit.textContent = '';
          copy.textContent = 'Every visible measurement must be greater than zero before the finder can build this plan.';
          plan.innerHTML = '';
          basis.textContent = '';
          note.textContent = '';
          tool._vepLastResult = null;
          return;
        }
        title.textContent = result.title;
        primary.textContent = result.primary;
        unit.textContent = result.unit;
        copy.textContent = result.copy;
        plan.innerHTML = result.plan.map(planItem).join('');
        basis.textContent = `Why this result: ${result.basis}`;
        note.textContent = result.note;
        tool._vepLastResult = result;
      };

      const resultText = (tool) => {
        const heading = tool.querySelector('.vep-tool__title')?.textContent.trim() || 'Pet Size and Fit Finder';
        const title = tool.querySelector('[data-result-title]')?.textContent.trim() || '';
        const primary = tool.querySelector('[data-result-primary]')?.textContent.trim() || '';
        const unit = tool.querySelector('[data-result-unit]')?.textContent.trim() || '';
        const copy = tool.querySelector('[data-result-copy]')?.textContent.trim() || '';
        const plan = Array.from(tool.querySelectorAll('.vep-tool__plan-item')).map((item) => item.innerText.trim());
        const basis = tool.querySelector('[data-result-basis]')?.textContent.trim() || '';
        const note = tool.querySelector('[data-result-note]')?.textContent.trim() || '';
        return [heading, title, `${primary} ${unit}`.trim(), copy, '', ...plan, '', basis, note].filter(Boolean).join('\n');
      };

      const setStatus = (tool, text) => {
        const status = tool.querySelector('[data-action-status]');
        if (status) status.textContent = text;
      };

      const reveal = (tool) => {
        const items = tool.querySelectorAll('[data-tool-reveal]');
        if (!('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        items.forEach((item) => observer.observe(item));
      };

      tools.forEach((tool) => {
        if (tool.dataset.toolInitialized === 'true') return;
        tool.dataset.toolInitialized = 'true';
        const form = tool.querySelector('[data-tool-form]');
        const storageKey = 'vep-pet-tool:size-fit:v2';
        try {
          const saved = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
          if (saved) core.restoreForm(form, saved);
        } catch (error) {
          window.localStorage.removeItem(storageKey);
        }
        form.addEventListener('input', () => update(tool));
        form.addEventListener('change', () => update(tool));
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          update(tool);
          core.track('size_fit', 'calculate');
        });
        form.addEventListener('reset', () => window.setTimeout(() => {
          setStatus(tool, '');
          update(tool);
        }));
        tool.querySelectorAll('[data-result-action]').forEach((button) => {
          button.addEventListener('click', async () => {
            const action = button.dataset.resultAction;
            if (action === 'copy') {
              const copied = await core.copyText(resultText(tool));
              setStatus(tool, copied ? 'Plan copied.' : 'Copy is unavailable in this browser.');
            }
            if (action === 'save') {
              window.localStorage.setItem(storageKey, JSON.stringify(core.captureForm(form)));
              setStatus(tool, 'Saved in this browser only.');
            }
            if (action === 'print') window.print();
            core.track('size_fit', action);
          });
        });
        update(tool);
        reveal(tool);
      });
    };

    if (window.VepPetTools) {
      initialize();
    } else {
      window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-travel-readiness-checklist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const core = window.VepPetTools;
      if (!core || typeof core.travelReadiness !== 'function') return;
      document.querySelectorAll('[data-travel-tool]').forEach((tool) => {
        if (tool.dataset.ready === 'true') return;
        tool.dataset.ready = 'true';
        const form = tool.querySelector('[data-tool-form]');
        const storageKey = 'vep-travel-readiness-v2';
        let completed = {};
        let result = null;
        let started = false;

        const escapeHtml = (value) => String(value)
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');
        const profile = () => ({
          ...core.captureForm(form),
          today: new Date().toISOString().slice(0, 10)
        });
        const setStatus = (message) => { tool.querySelector('[data-action-status]').textContent = message; };
        const saveState = (message = '') => {
          try {
            localStorage.setItem(storageKey, JSON.stringify({ profile: core.captureForm(form), completed }));
            if (message) setStatus(message);
            return true;
          } catch (error) {
            setStatus('This browser could not save the checklist. Copy or print it instead.');
            return false;
          }
        };
        const restoreState = () => {
          try {
            const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
            if (!saved) return false;
            core.restoreForm(form, saved.profile);
            completed = saved.completed && typeof saved.completed === 'object' ? saved.completed : {};
            return true;
          } catch (error) {
            return false;
          }
        };
        const updateProgress = () => {
          if (!result) return;
          const checked = result.tasks.filter((task) => completed[task.id]).length;
          const total = result.tasks.length;
          const percent = total ? Math.round((checked / total) * 100) : 0;
          const progress = tool.querySelector('[data-progress]');
          progress.style.setProperty('--complete', `${percent}%`);
          progress.setAttribute('aria-valuenow', String(percent));
          tool.querySelector('[data-progress-text]').textContent = `${checked} of ${total} checked`;
          const openCritical = result.tasks.find((task) => task.priority === 'critical' && !completed[task.id]);
          const openTask = openCritical || result.tasks.find((task) => !completed[task.id]);
          setStatus(openTask ? `Next: ${openTask.title}.` : 'All tasks are checked. Reconfirm live rules and conditions before leaving.');
        };
        const render = () => {
          result = core.travelReadiness(profile());
          const validIds = new Set(result.tasks.map((task) => task.id));
          completed = Object.fromEntries(Object.entries(completed).filter(([id, value]) => validIds.has(id) && value));
          tool.querySelector('[data-result-primary]').textContent = result.primary;
          tool.querySelector('[data-result-title]').textContent = result.title;
          tool.querySelector('[data-result-copy]').textContent = result.copy;
          tool.querySelector('[data-result-basis]').textContent = result.basis;
          tool.querySelector('[data-result-note]').textContent = result.note;
          tool.querySelector('[data-result-list]').innerHTML = result.categories.map((category) => `
            <section class="vep-tool__check-group" aria-labelledby="${tool.id}-${escapeHtml(category.phase)}-title">
              <h3 id="${tool.id}-${escapeHtml(category.phase)}-title">${escapeHtml(category.title)}</h3>
              ${category.tasks.map((task) => {
                const id = `${tool.id}-${task.id}`;
                return `<div class="vep-tool__check"><input id="${escapeHtml(id)}" type="checkbox" data-task-id="${escapeHtml(task.id)}" ${completed[task.id] ? 'checked' : ''}><label for="${escapeHtml(id)}"><strong>${escapeHtml(task.title)}</strong><span>${escapeHtml(task.text)}</span>${task.priority === 'critical' ? '<em class="vep-tool__priority">Resolve before travel</em>' : ''}</label></div>`;
              }).join('')}
            </section>
          `).join('');
          tool.querySelectorAll('[data-task-id]').forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
              completed[checkbox.dataset.taskId] = checkbox.checked;
              saveState();
              updateProgress();
              core.track('travel-readiness', 'result');
            });
          });
          const sourceBox = tool.querySelector('[data-official-links]');
          if (result.officialLinks.length) {
            sourceBox.hidden = false;
            sourceBox.innerHTML = `<strong>Official starting points for this route</strong>${result.officialLinks.map((link) => `<a href="${escapeHtml(link.url)}" rel="noopener" target="_blank">${escapeHtml(link.title)}</a>`).join('')}`;
          } else {
            sourceBox.hidden = true;
            sourceBox.innerHTML = '';
          }
          updateProgress();
        };
        const copyChecklist = () => {
          const lines = [result.title, result.basis, ''];
          result.categories.forEach((category) => {
            lines.push(category.title);
            category.tasks.forEach((task) => lines.push(`${completed[task.id] ? '[x]' : '[ ]'} ${task.title}: ${task.text}`));
            lines.push('');
          });
          if (result.officialLinks.length) {
            lines.push('Official starting points');
            result.officialLinks.forEach((link) => lines.push(`${link.title}: ${link.url}`));
            lines.push('');
          }
          lines.push(result.note);
          return lines.join('\n');
        };

        const restored = restoreState();
        render();
        if (restored) setStatus('Restored the checklist saved in this browser.');
        form.addEventListener('change', () => {
          if (!started) {
            core.track('travel-readiness', 'start');
            started = true;
          }
          render();
          saveState('Updated and saved in this browser.');
        });
        tool.querySelectorAll('[data-result-action]').forEach((button) => {
          button.addEventListener('click', async () => {
            const action = button.dataset.resultAction;
            if (action === 'copy') {
              const copied = await core.copyText(copyChecklist());
              setStatus(copied ? 'Checklist copied.' : 'Copy was not available. Use Print instead.');
            } else if (action === 'save') {
              saveState('Saved in this browser only.');
            } else if (action === 'print') {
              window.print();
            } else if (action === 'reset') {
              form.reset();
              completed = {};
              try { localStorage.removeItem(storageKey); } catch (error) {}
              render();
              setStatus('Checklist reset.');
            }
            core.track('travel-readiness', action);
          });
        });
      });
    };

    if (window.VepPetTools) initialize();
    else window.addEventListener('vep:pet-tools-ready', initialize, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-viva-essence-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vep-why]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => {
        section.querySelectorAll('[data-vep-why-reveal]').forEach((item) => item.classList.add('is-visible'));
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    sections.forEach((section) => {
      section.querySelectorAll('[data-vep-why-reveal]').forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
